import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "@/assets/main.scss";
import Donut from 'vue-css-donut-chart';
import 'vue-css-donut-chart/dist/vcdonut.css';

Vue.use(Donut);
Vue.config.productionTip = false;
import rules from "./service/rules.js";
Vue.prototype.$rules = rules;

import "./plugins/inputmask.js";
import masks from "./service/mask";
Vue.prototype.$masks = masks;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
